import { OpenAPI } from "@farmact/invoice-api-client";
import { OpenAPI as MailApi } from "@farmact/mail-api-client";
import { OpenAPI as NotificationApi } from "@farmact/notification-app-client";
import { OpenAPI as TrackerApi } from "@farmact/tracker-api-client";
import { getAuth, onIdTokenChanged } from "firebase/auth";
import { useEffect } from "react";
import { OpenAPI as DatevApi } from "@farmact/datev-app-client";

export function useConfigureApiClients() {
    useEffect(() => {
        return onIdTokenChanged(getAuth(), async nextUser => {
            if (nextUser) {
                const token = await nextUser.getIdToken();
                OpenAPI.TOKEN = token;
                MailApi.TOKEN = token;
                TrackerApi.TOKEN = token;
                NotificationApi.TOKEN = token;
                DatevApi.TOKEN = token;
            } else {
                OpenAPI.TOKEN = undefined;
                MailApi.TOKEN = undefined;
                TrackerApi.TOKEN = undefined;
                NotificationApi.TOKEN = undefined;
                DatevApi.TOKEN = undefined;
            }
        });
    }, []);
}
